import { render, staticRenderFns } from "./GZ.vue?vue&type=template&id=2962af60&scoped=true&"
import script from "./GZ.vue?vue&type=script&lang=js&"
export * from "./GZ.vue?vue&type=script&lang=js&"
import style0 from "./GZ.vue?vue&type=style&index=0&id=2962af60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2962af60",
  null
  
)

export default component.exports